module.exports = __webpack_public_path__ + "static/media/telas_500x325.2959bf08.png";